exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".auth-form {\n  margin: 0 auto !important;\n  display: flex;\n  padding: 100px 40px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/forms.scss
// module id = 397
// module chunks = 0